import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import Password from '../../../Password/Password';

import {
  TXTWCL_Create_Password,
  TXTWCL_OkX_N0X_Next_upX_set_a_passwor_ELL
} from './SignupPassword.messages.json';

const SignupPassword: React.FC = () => {
  const {
    values: { userId }
  } = useWizardContext();

  return (
    <Container
      page={SignupPassword}
      headerProps={{
        title: <Translation {...TXTWCL_Create_Password} />
      }}
      pageTopTitle={
        <Translation {...TXTWCL_OkX_N0X_Next_upX_set_a_passwor_ELL} values={{ 0: userId }} />
      }
    >
      <fieldset>
        <Password />
      </fieldset>
      <CTAButton />
    </Container>
  );
};

SignupPassword.displayName = 'SignupPassword';

export default SignupPassword;
